import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers';
import store from '../../../store/store';
import { BaseComponent } from '../../base-component/base-component';
import { StoreState } from '../../../store/store.interface';
import { getQueryParam } from '../../../common/utils/util';
import { fetchSchoolByXid } from '../../user-profile/thunks/get-school-by-xid.thunk';
import { getSchoolByIdResponse, getSchoolByIdStatus } from '../../user-profile/user-profile.selectors';
import { ActionStatus } from '../../../common/constants/action-status';
import { booleanConverter } from '../../../common/converters';

/**
 * Component to display the filter used to search for Learning Technology Representatives (LTR).
 * It shows the search term based on the selected school or zipcode.
 * It also displays a message when there are no results found.
 */
@customElement('mhecomm-ltr-search-results')
export class LearningTechnologyRepresentativeSearchResults extends connect(store)(BaseComponent) {

  /**
   * Indicates whether there are results so that the component can display the no results message.
   */
  @property({converter: booleanConverter})
  hasResults: boolean = true;

  @state()
  private zipcode: string = '';

  @state()
  private schoolName: string = '';

  protected firstUpdated(_changedProperties: Map<string | number | symbol, unknown>) {
    super.firstUpdated(_changedProperties);
    this.zipcode = getQueryParam('zipcode') ?? '';
    const schoolId = getQueryParam('schoolId') ?? '';
    if (schoolId) {
      store.dispatch(fetchSchoolByXid(schoolId));
    }
  }

  stateChanged(state: StoreState) {
    if (getSchoolByIdStatus(state) === ActionStatus.succeeded) {
      this.schoolName = getSchoolByIdResponse(state)[0].name ?? '';
    }
  }

  renderComp() {
    return html`
      <div class="row">
        <div class="row">
          <div class="col-12">
            <h5 class=fw-bold>Search Results</h5>
          </div>
        </div>
        ${this.hasResults ? html`
          <div class="row mb-1">
            <p>Results for "<strong class="text-capitalize">${this.getSearchTerm().toLowerCase()}</strong>". Contact the
              representative that you think is most
              appropriate for your needs</p>
          </div>
        ` : html`
          <div class="row mb-1">
            <p>No results found, please try searching again.</p>
          </div>`}
      </div>
      <div class="row px-2">
        <hr aria-hidden="true"/>
      </div>
    `;
  }

  private getSearchTerm(): string {
    return this.schoolName || this.zipcode || '';
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-ltr-search-results': LearningTechnologyRepresentativeSearchResults;
  }
}
